export const linkHome = () => `/`;
export const linkMyRecipes = () => `/my-recipes`;
export const linkRecipe = (recipeId: string) => `/my-recipes/${recipeId}`;
export const linkLogin = () => `/user/login`;
export const linkRegister = () => `/user/register`;
